import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useAttributeLabel = (
  name: string,
  namespace = 'prescription',
  concat = ''
) => {
  const { t } = useTranslation([namespace])
  const suffix = concat ? `.${concat}` : ''
  return useMemo(() => {
    const [side, ...rest] = name.split('_')
    // Detect if the side is present
    const hasSide = side === 'l' || side === 'r'
    // If the side is present, we need to get the attribute and the side label
    if (hasSide) {
      // Get the attribute
      const attribute = rest.join('_')
      const attributeKey = `${namespace}:${attribute.toLowerCase()}${suffix}`
      const label = t(attributeKey, attribute)

      const sideLabel = t(`${namespace}:${side.toLowerCase()}${suffix}`, side)
      return `${sideLabel} ${label}`
    }

    const attributeKey = `${namespace}:${name.toLowerCase()}${suffix}`
    const label = t(attributeKey, name)

    return label
  }, [namespace, name, t, suffix])
}

export const usePrescriptionLabel = (name: string) => {
  return useAttributeLabel(name, 'prescription')
}

export const useCustomizationLabel = (name: string, concat?: string) => {
  return useAttributeLabel(name, 'customization', concat)
}
